// extracted by mini-css-extract-plugin
module.exports = {"voteIcon":"MobileProposalVoteEvent_voteIcon__rlh4E","proposalTitle":"MobileProposalVoteEvent_proposalTitle__3enqs"};